export const paperlessModalContent = {
  title: 'STR_CONFIRM_PAPERLESS_DELIVERY',
  descriptions: [
    {
      id: 'STR_PAPERLESS_MODAL_DESCRIPTION_1',
      isLink: false,
    },
    {
      id: 'STR_PAPERLESS_MODAL_DESCRIPTION_2',
      isLink: true,
      url: `${
        import.meta.env.VITE_CIGNA_CLOUD_STORAGE_LINK
      }/public/forms/2026/ElectronicDeliveryAgreement.pdf`,
      target: '_blank',
    },
  ],
  cancelButton: 'STR_CANCEL',
  confirmButton: 'STR_GO_PAPERLESS',
};

export const buttonStyles = {
  height: '$three',
  whiteSpace: 'nowrap',
  backgroundColor: 'transperent',
  '&:hover, &:active, &:focus': {
    backgroundColor: '$interactiveBackgroundHovered',
    color: '$interactiveActionHovered',
    textDecoration: 'none',
  },
};

export const stackLayoutStyles = {
  '> *': {
    flex: '1',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

export const linkStyles = {
  textAlign: 'center',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  color: '$interactiveActionPrimary',
  fontSize: '$bodyOne',
};
